<div class="shares-container">
  <table-user-roles-table
    [shares]="sortedShares()"
    (stopSharing)="deleteShare.emit($event)"
    (updateShare)="updateShare.emit($event)"
    [ownRole]="'OWNER'"
    [item]="deviceType()"
    class="user-table"
    (addShare)="createShare.emit()"
    [allowOwner]="true"
  >
  </table-user-roles-table>
</div>
